import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { mutator } from 'satcheljs';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';

export default mutator(updateSidePaneType, actionMessage => {
    const fullComposeViewState = getFullComposeViewState();
    if (fullComposeViewState) {
        fullComposeViewState.currentSidePaneType = actionMessage.newSidePaneType;
    }
});

export { default as SidePaneType } from 'owa-calendar-sidepane/lib/schema/SidePaneType';
